import { render, staticRenderFns } from "./IndexNew.vue?vue&type=template&id=37c97335&"
import script from "./IndexNew.vue?vue&type=script&lang=js&"
export * from "./IndexNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports